<template>


  <zen-one :showuserinfo="false" :crumbs="crumbs" title="">
   <div class="mb3 text-left">
         <span class="no_permohonan">{{data.no_permohonan}}</span> | <w-tag class="mr4" bg-color="primary" round> {{data.status_keterangan}} </w-tag>
      </div>
    <z-page :title="title" >  
    <div class="table_scrol">
        <table class="w-table" color="light" ><tbody><tr><td>
      <w-card bg-color="" class="">
        <w-form class="" v-model="data.valid" v-model:errors-count="data.errorsCount" @validate="onValidate" @success="onSuccess">
          <div class="w-flex wrap smd-column" >
              <div class="grow " style="line-height: 35px">
               <table >
                <tbody>
               <template v-if="$zutil.role('7') || $zutil.role('8') || $zutil.role('9') || $zutil.role('10') || $zutil.role('4') ">
                  <tr class="row_data">
                     <td><b> Nama Penternak</b></td>
                     <td><b>:</b></td>
                     <td>{{data.user_nama}}</td>
                  </tr>
               </template>
               <template v-if=" $zutil.role('1') || $zutil.role('5')">
                  <tr class="row_data">
                     <td><b> Nama Juruteknik/Jurusuntik</b></td>
                     <td><b>:</b></td>
                     <td>{{data.juruteknik}}</td>
                  </tr>
               </template>
                   <tr class="row_data">
                     <td><b>Tarikh Mohon</b></td>
                     <td><b>:</b></td>
                     <td>{{$zutil.dateformat(data.tarikh_mohon)}} / {{$zutil.formatDateToTime(data.tarikh_mohon)}}</td>
                  </tr>
                  </tbody>
               </table>
              </div>
              <div class="mx2"></div>
              <div class="grow " style="line-height: 35px">
               <table >
                <tbody>
                  <tr class="row_data">
                     <td><b>ID Premis</b></td>
                     <td><b>:</b></td>
                     <td>{{data.no_premis}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>Tujuan PD</b></td>
                     <td><b>:</b></td>
                     <td>{{data.lkp_tujuan}}</td>
                  </tr>
                  </tbody>
               </table>
              </div>
              <div class="mx2"></div>
              <div class="grow " style="line-height: 35px">
               <table >
                <tbody>
                  <tr class="row_data">
                     <td><b>Nama Premis</b></td>
                     <td><b>:</b></td>
                     <td>{{data.nama_premis}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>Pasung</b></td>
                     <td><b>:</b></td>
                     <td>
                        <div v-if="data.pasung==1">Ada</div>
                        <div v-else>Tidak Ada</div>
                     </td>
                  </tr>
                  </tbody>
               </table>
              </div>
              <div class="mx2"></div>
            </div>
            <!-- <w-flex justify-end class="mt2" v-if="data.lkp_status_id==32 || data.lkp_status_id==27 && $zutil.anyRole(['7','8','9','10'])">
                <w-button class="my1" :loading="data.submitted && !data.sent" type="success">
                  <w-icon dark tile class="mr2">fal fa-save</w-icon> SIMPAN
                </w-button>
            </w-flex> -->
            <!-- <w-flex justify-end class="mt2" v-if="data.lkp_status_id==18">
                <w-button class="my1" bg-color="success">
                  <w-icon dark tile class="mr2">fal fa-save</w-icon> Cetak
                </w-button>
            </w-flex> -->
          </w-form>
       </w-card>
    </td></tr></tbody></table>
          <br>

  <template v-if="$zutil.anyRole(['5']) && data.juruteknik_id == $page.props.auth.user.id">
         <w-tabs :items="tabs" :no-slider="false" color="black" active-class="blue" slider-color="blue"  v-model="activeTab">
           <template #item-content.1>
               <Pemeriksaan :d_data="data" v-if="data.id > 0" />
           </template>
           <template #item-content.2>
               <CajPerkhidmatan :d_data="data" v-if="data.id > 0"/>
           </template>
         </w-tabs>
  </template>
  <template v-else>

      <template v-if="$zutil.anyRole(['5'])">
         <w-card title-class="blue-dark4--bg white" style="font-size: 13px;" :title="'MAKLUMAT TERNAKAN 123'" >
            <template #title>
               MAKLUMAT TERNAKAN
               <w-flex justify-end class="mt2">
                  <w-button @click="isMinimizedMakTer = !isMinimizedMakTer">
                     <template v-if="isMinimizedMakTer">
                        <w-icon dark tile class="mr2">fal fa-angle-double-down</w-icon>
                     </template>
                     <template v-else>
                        <w-icon dark tile class="mr2">fal fa-angle-double-up</w-icon>
                     </template>
                  </w-button>
               </w-flex>
            </template>
          <div v-show="!isMinimizedMakTer">
          <div class="table-profil-scrol">
            <table class="w-table" color="light" >
             <thead>
               <tr>
                 <th class="w-table__header  text-center" width="1%">BIL</th>
                 <th class="w-table__header  text-center">NO KES PD</th>
                 <th class="w-table__header  text-center">ID TERNAKAN/NAMA</th>
                 <th class="w-table__header  text-center">BAKA</th>
                 <th class="w-table__header  text-center">TARIKH BERANAK TERDAHULU</th>
                 <th class="w-table__header  text-center">TARIKH SUNTIKAN TERDAHULU / NAMA JURUTEKNIK/JURUSUNTIK</th>
                 <th class="w-table__header  text-center">KAEDAH PEMERIKSAAN</th>
                 <th class="w-table__header  text-center">STATUS</th>
                 <th class="w-table__header  text-center">USIA KEBUNTINGAN (HARI)</th>
                 <th class="w-table__header  text-center">TARIKH JANGKA BERANAK</th>
               </tr>
             </thead>
             <tbody>
               <!-- <template v-if="data.ternakan_list.length == 0">
                 <tr class="w-table__row" >
                   <td class="w-table__cell text-center" colspan="5"> Tiada Data.</td>
                 </tr>
               </template> -->
               <template v-for="(dt, ind) in data.ternakan_list">
                 <tr class="w-table__row" >
                   <td class="w-table__cell text-left" >{{ind+1}}</td>
                   <td class="w-table__cell text-left" style="margin:5px;">{{dt.no_kes}}</td>
                   <td class="w-table__cell text-left" style="margin:5px;">{{dt.ternakan_nama}}</td>
                   <td class="w-table__cell text-left" style="margin:5px;">{{dt.baka}}</td>
                   <td class="w-table__cell text-left"> {{dt.tarikh_beranak_terdahulu}} </td>
                   <td class="w-table__cell text-left" style="margin:10px;">
                     {{$zutil.dateformat(dt.tarikh_suntik_terdahulu)}} | {{dt.nama_juruteknik_terdahulu}}</td>
                   <td class="w-table__cell text-left" style="margin:30px;">
                       {{dt.lkpKaedahPemeriksaan_keterangan}}
                   </td>
                   <td class="w-table__cell text-left" style="margin:80px;">
                       <template v-if="dt.bunting==1">BUNTING</template><template v-else>TIDAK BUNTING</template>
                   </td>
                     <td class="w-table__cell text-right" >
                       {{dt.usia_bunting}}
                     </td>
                   <td class="w-table__cell text-center" style="margin:5px;">{{$zutil.dateformat(dt.jankaan_kelahiran)}}</td>
                 </tr>
               </template>
             </tbody>
           </table>
        </div>
     </div>
         </w-card>
           <br>
           <br>
           <w-card title-class="blue-dark4--bg white" style="font-size: 13px;" :title="'CAJ PERKHIDMATAN'" >
            <template #title>
               CAJ PERKHIDMATAN
               <w-flex justify-end class="mt2">
                  <w-button @click="isMinimizedCajPer = !isMinimizedCajPer">
                     <template v-if="isMinimizedCajPer">
                        <w-icon dark tile class="mr2">fal fa-angle-double-down</w-icon>
                     </template>
                     <template v-else>
                        <w-icon dark tile class="mr2">fal fa-angle-double-up</w-icon>
                     </template>
                  </w-button>
               </w-flex>
            </template>
            <div v-show="!isMinimizedCajPer">
               <figure class="table-aims">
                   <figure class="table">
                       <table class="w-table"><tbody><tr><td>
                          <div class="grow " style="line-height: 35px">
                             <table >
                              <tbody>
                                    <tr>
                                        <td colspan="3"><strong>Tarikh / Perkhidmatan</strong></td>
                                        <td width="1px">:</td>
                                        <td colspan="2">{{$zutil.dateformat(data.tarikh_pemeriksaan_format)}}</td>
                                        <td width="150px">&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td width="150px">&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td width="1px"><b>1.</b></td>
                                        <td colspan="2"><strong>Konsultasi / Perkhidmatan</strong></td>
                                        <td>:</td>
                                        <td colspan="2">
                                          <w-tag
                                            class="mr4"
                                            bg-color="primary"
                                            round>
                                             <template v-if="data.konsutasi_pemeriksaan_ya_tidak==1">Berbayar</template><template v-else>Subsidi</template>
                                          </w-tag>
                                          <strong>RM</strong> {{$zutil.formatDecimal(data.konsutasi)}}</td>
                                        <td>&nbsp;</td>
                                        <td><b>3.</b></td>
                                        <td colspan="2"><strong>Caj Perjalanan</strong></td>
                                        <td>:</td>
                                        <td colspan="2" align="left"><strong>RM</strong> {{$zutil.formatDecimal(data.pengangkutan)}}</td>
                                    </tr>
                                    <tr>
                                        <td width="1px"><b>2.</b></td>
                                        <td colspan="2"><strong>Caj Pemeriksaan PD</strong></td>
                                        <td>:</td>
                                        <td colspan="2">
                                          <strong>RM</strong> {{$zutil.formatDecimal(data.caj_pemeriksaan_pd)}}</td>
                                        <td>&nbsp;</td>
                                        <td><b>4.</b></td>
                                        <td><strong>Caj Lain-Lain (Jika Ada)</strong></td>
                                        <td>&nbsp;</td>
                                        <td>:</td>
                                        <td align="left"><strong>RM</strong> {{$zutil.formatDecimal(data.caj_lain_pemeriksaan)}}</td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td colspan="2"><strong>Nyatakan</strong></td>
                                        <td>:</td>
                                        <td><template v-if="data.nyatakan_pemeriksaan==null">-</template>
                                             <template v-else>{{data.nyatakan_pemeriksaan}}</template></td>
                                        <td>&nbsp;</td>
                                       </tr>
                                    <tr>
                                        <td colspan="3">&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td colspan="3"><strong>Jumlah Caj Keseluruhan</strong></td>
                                        <td>:</td>
                                        <td colspan="2" align="left"><strong>RM</strong> {{$zutil.formatDecimal(data.keseluruhan)}}</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td><strong>Jumlah Caj Subsidi Kerajaan</strong></td>
                                        <td>&nbsp;</td>
                                        <td>:&nbsp;</td>
                                        <td align="left"><strong>RM</strong> {{$zutil.formatDecimal(data.subsidi)}}</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td colspan="3"><strong>Jumlah Caj Yang Perlu Dibayar</strong></td>
                                        <td>:</td>
                                        <td colspan="2" align="left"><strong>RM</strong> {{$zutil.formatDecimal(data.perlu_bayar)}}</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                    </tr>
                                    </tbody>
                                 </table>
                              </div>
                           </td></tr></tbody></table>
                      </figure>
                  </figure>
               </div>
            </w-card>
           <br>
           <w-flex justify-end class="mt2" v-if="data.lkp_status_id==35 && $zutil.anyRole(['1','5'])">
                <w-button class="my1" :loading="data.submitted && !data.sent" bg-color="success" type="success" @click="sahkan(18)">
                  <w-icon dark tile class="mr2">fal fa-check-circle</w-icon> SAHKAN
                </w-button>&nbsp;
                <w-button class="my1" :loading="data.submitted && !data.sent" bg-color="error" type="success" @click="semaksemula()">
                  <w-icon dark tile class="mr2">fal fa-times-circle</w-icon> SEMAKAN SEMULA
                </w-button>
            </w-flex>
      </template>
      <template v-else>
         <w-tabs :items="tabs" :no-slider="false" color="black" active-class="blue" slider-color="blue"  v-model="activeTab">
           <template #item-content.1>
               <Pemeriksaan :d_data="data" v-if="data.id > 0" />
           </template>
           <template #item-content.2>
               <CajPerkhidmatan :d_data="data" v-if="data.id > 0"/>
           </template>
         </w-tabs>
         
      </template>
  </template>
      <div class="mt2 text-left" v-if="data.lkp_status_id==35 || data.lkp_status_id==18">
          <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="tutup">TUTUP</w-button>&nbsp;
        </div>
      </div>
    </z-page>
    <w-dialog
            v-model="dialogSemakan.show"
            :fullscreen="dialogSemakan.fullscreen"
            :width="dialogSemakan.width"
            :persistent="dialogSemakan.persistent"
            :persistent-no-animation="dialogSemakan.persistentNoAnimation"
            title-class="primary-dark1--bg white">
            <template #title>
               <w-icon class="mr2">fal fa-list</w-icon>
               Semak Semula Perkhidmatan
            </template>
            <br>{{dialogSemakan.form}}
            <w-form 
               ref="form" 
               v-model="dialogSemakan.valid"
               @validate="sahkan(27)"
               @success="success"
             >
            <div class="w-flex wrap smd-column" >
                <w-textarea style="margin:5px;" label="Catatan *"  placeholder="Sila masukan.." class="mt4" outline  v-model="dialogSemakan.item.catatan" :validators="[validators.required]"/>
            </div>
            </w-form>
            <template #actions>
               <div class="spacer" />
               <w-button bg-color="grey-light5--bg" @click="dialogSemakan.show = false">TUTUP</w-button>
               &nbsp;
               <w-button class="mr2" :loading="dialogSemakan.loading" :disabled="dialogSemakan.loading || dialogSemakan.item.catatan == null" @click="sahkan(27)">
                  <w-icon m class="mr2">fal fa-paper-plane</w-icon>Hantar
               </w-button>
            </template>
         </w-dialog>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
// import Baka from './Sub/Baka.vue';
// import Perkhidmatan from './Sub/Perkhidmatan.vue';
import Pemeriksaan from './Sub/Pemeriksaan.vue';
import CajPerkhidmatan from './Sub/CajPerkhidmatan.vue';
import VueQrcode from 'vue-qrcode'

export default {
  extends: ZResource,
  components: {
     VueQrcode, Pemeriksaan, CajPerkhidmatan
  },
  props: {
    id: [Array, Object, String],
    segmenName: [Array, Object],
  },
  data() {
    return {
      resourceurl: "pd.permohonan",
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Perkhidmatan PD', route: '/pd/permohonan' },
        { label: 'Permohonan PD', route: '/pd/permohonan' },
        { label: 'Papar', route: '/pd/permohonan/show'+this.id },
      ],
      data : {id : 0},
      attahecment : [],
      slides : [],
      ternakan_list: [],
      dialogSemakan: {
         valid: false,
         show: false,
         fullscreen: false,
         persistent: true,
         persistentNoAnimation: false,
         loading: false,
         width: 900,
         item: {
            catatan:null
         }
      },
      isMinimizedCajPer: false,
      isMinimizedMakTer: false,
      activeTab : 0,
      title: '',
      tabs: [
      		  { title: 'PEMERIKSAAN KEBUNTINGAN', content: '' },
            { title: 'CAJ PERKHIDMATAN', content: ''}
          ]
    }
  },
  methods: {
    semaksemula(){
         this.dialogSemakan.show = true;
      },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },

    tutup(){
      // if(this.data.lkp_status_id == 19){
      //    this.$inertia.visit(window.route('pd.permohonan.index'));
      //  }else if(this.data.art_id != 0){
      //     this.$inertia.visit(window.route('pd.permohonan.aiet'));
      //  }else{
      //   this.$inertia.visit(window.route('pd.permohonan.index'));
      //  }
       
        this.$inertia.visit(window.route('art.semakan.index'));
    },

    getData()
    {
      const params = new URLSearchParams(window.location.search);
      const tab = params.get('tab');
      if(tab){
        this.activeTab = parseInt(tab) - 1;
      }
      this.$zcomm.get(this.api_service + 'art/show/'+this.id, {}).then(res => {
        this.data = res;
        if(this.data.pemeriksaan==1){
          this.tabs[1].disabled = false;
        }else{
          this.tabs[1].disabled = true;
        };
        if (this.data.tarikh_pemeriksaan_art == null && this.data.tarikh_laporan == null|| this.data.tarikh_laporan == '') {
          // var today = new Date();
          //  this.data.tarikh_pemeriksaan = today.toISOString().split('T')[0];
          //  this.data.tarikh_laporan = today.toISOString().split('T')[0];

        }
      })
    },
    onSuccess(){
      if (this.data.tarikh_pemeriksaan != '' && this.data.tarikh_laporan != '') {
        if (this.data.id > 0) 
        {
          
          this.$zcomm.update(this.resourceurl + '.update', this.data.id, {tarikh_pemeriksaan:this.data.tarikh_pemeriksaan, tarikh_laporan:this.data.tarikh_laporan, save_tarikh_pemeriksaan:1})
          .then(res => {
            if (typeof this.onAfterEdit === "function") {
              this.onAfterEdit()
            }
            if (this.form.hantar==1) {
                // this.$inertia.visit(this.$route('art.permohonan.show', this.form.id));
            }else{
              this.getData();
                this.$zutil.notify("Berjaya disimpan", true);
                this.$inertia.visit(this.$route('pd.permohonan.papar', this.data.id));
                // this.$inertia.visit(this.$route('art.permohonan.form', this.form.id));
            }
            // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
          })
        }
     }else{
         this.$zutil.notify("Sila lengkapkan Tarikh Pemeriksaan & Tarikh Laporan", false);
     }
      
    },
    sahkan(item) {
        if (item == 27) {
            let isValid = true;
            this.dialogSemakan.loading=true;
            if (!this.dialogSemakan.item.catatan) {
              isValid = false;
              this.dialogSemakan.loading=false;
            }
            if (!isValid) 
            {
              this.$zutil.notify("Catatan Wajib diisi", false);
              this.dialogSemakan.loading=false;
              return false;
            }
            this.data.semakan_catatan = this.dialogSemakan.item.catatan;
         }
        this.loading = true;
        this.$swal({
          title: 'Anda Pasti?',
          // text: "Are you sure want to delete this item!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak'
        }).then((result) => {
        if (result.value) {
          if(this.data.id > 0){
            this.data.lkp_status_id = item;
            this.data.peternak = 1;
          this.$zcomm.update(this.resourceurl + '.update', this.data.id, this.data)
              .then(res => {
                console.log(res);
                  this.dialog.show = false;
                  this.$inertia.reload();
              })
              .catch(err => {

              })
              .finally(() => {
                
                this.$inertia.visit(this.$page.url)
              });
              this.dialog.loading = false;
          }
        }else{ this.loading = false;
              this.dialogSemakan.loading=false;}

        }) 
      },
    
   

  },
  watch: {

  },
  mounted() {
      this.getData();
      if(this.$zutil.anyRole(['5'])){
         this.title = 'Rumusan Pemeriksaan Kebuntingan';
      }else{
         this.title = 'Senarai Pemeriksaan Kebuntingan (PD)';
      }
  },
}
</script>
<style>

.table-aims td{
   padding: 7px;
}

.no_permohonan {
    font-weight: bold;
    font-size: 16px;
    line-height: 30px;
}

</style>